import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentTypeIndexComponent } from './document-type-index/document-type-index.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path:'',
        component: DocumentTypeIndexComponent,
        data: {
          urls: [
            {title: 'Documentos', url: 'setting/documents'}
          ]
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentTypeRoutingModule { }
